import { Component } from 'react';
import T from 'prop-types';

class DescriptionAttachable extends Component {
  constructor(props) {
    super(props);
    const { value } = props;
    this.state = {
      isAttachedToDescription: !value || props.description === value,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const hasValueChanged = nextProps.value !== this.props.value;
    const hasValueChangedToOtherThanDescription =
      hasValueChanged && nextProps.value !== nextProps.description;
    if (hasValueChangedToOtherThanDescription) {
      this.detachFromDescription();
      return;
    }

    const { value, setValue, description } = nextProps;
    if (this.state.isAttachedToDescription && value !== description) {
      setValue(description);
    }
  }

  detachFromDescription = () => {
    this.setState({
      isAttachedToDescription: false,
    });
  };

  attachToDescription = () => {
    this.setState({
      isAttachedToDescription: true,
    });
    const { value, setValue, description } = this.props;
    if (description !== value) {
      setValue(description);
    }
  };

  render() {
    return this.props.children({
      isAttachedToDescription: this.state.isAttachedToDescription,
      attachToDescription: this.attachToDescription,
      detachFromDescription: this.detachFromDescription,
    });
  }
}

DescriptionAttachable.propTypes = {
  value: T.string.isRequired,
  description: T.string.isRequired,
  setValue: T.func.isRequired,
  children: T.func.isRequired,
};

export default DescriptionAttachable;
